import { ApprovalTypes, type ApprovalType } from '../types/ApprovalType';

export const APPROVAL_READ_SCOPES = {
  [ApprovalTypes.MARKETING_EMAIL]: 'email-approval-read',
  [ApprovalTypes.BLOG_POST]: 'blog-approval-read',
  [ApprovalTypes.LANDING_PAGE]: 'landingpages-approval-read',
  [ApprovalTypes.SITE_PAGE]: 'pages-approval-read',
  [ApprovalTypes.DEAL]: 'deal-approval-read',
  [ApprovalTypes.KNOWLEDGE_ARTICLE]: 'knowledge-article-approval-read',
  [ApprovalTypes.QUOTE]: 'quote-approval-read',
  [ApprovalTypes.SOCIAL_BROADCAST]: 'social-broadcast-approval-read',
  [ApprovalTypes.CONNECTED_APP]: 'app-governance-approval-read',
} as const satisfies Record<ApprovalType, string>;

export const APPROVAL_WRITE_SCOPES = {
  [ApprovalTypes.MARKETING_EMAIL]: 'email-approval-write',
  [ApprovalTypes.BLOG_POST]: 'blog-approval-write',
  [ApprovalTypes.LANDING_PAGE]: 'landingpages-approval-write',
  [ApprovalTypes.SITE_PAGE]: 'pages-approval-write',
  [ApprovalTypes.DEAL]: 'deal-approval-write',
  [ApprovalTypes.KNOWLEDGE_ARTICLE]: 'knowledge-article-approval-write',
  [ApprovalTypes.QUOTE]: 'quote-approval-write',
  [ApprovalTypes.SOCIAL_BROADCAST]: 'social-broadcast-approval-write',
  [ApprovalTypes.CONNECTED_APP]: 'app-governance-approval-write',
} as const satisfies Record<ApprovalType, string>;

// Approve scopes follow a different naming convention than read/write scopes.
// Read/write use `{type}-approval-{action}`, but approve scopes use `{domain-noun}-approve`.
// These names are defined in the backend ApprovalTypeToApproveScopeProvider.
export const APPROVAL_APPROVE_SCOPES = {
  [ApprovalTypes.MARKETING_EMAIL]: 'marketing-emails-approve',
  [ApprovalTypes.BLOG_POST]: 'blog-posts-approve',
  [ApprovalTypes.LANDING_PAGE]: 'landing-pages-approve',
  [ApprovalTypes.SITE_PAGE]: 'website-pages-approve',
  [ApprovalTypes.DEAL]: 'deals-approve',
  [ApprovalTypes.KNOWLEDGE_ARTICLE]: 'knowledge-articles-approve',
  [ApprovalTypes.QUOTE]: 'quotes-approve',
  [ApprovalTypes.SOCIAL_BROADCAST]: 'social-broadcast-approve',
  [ApprovalTypes.CONNECTED_APP]: 'app-governance-approve',
} as const satisfies Record<ApprovalType, string>;

export const MARKETING_STUDIO_APPROVAL_READ_SCOPES = [
  APPROVAL_READ_SCOPES[ApprovalTypes.MARKETING_EMAIL],
  APPROVAL_READ_SCOPES[ApprovalTypes.SOCIAL_BROADCAST],
  APPROVAL_READ_SCOPES[ApprovalTypes.BLOG_POST],
  APPROVAL_READ_SCOPES[ApprovalTypes.SITE_PAGE],
  APPROVAL_READ_SCOPES[ApprovalTypes.LANDING_PAGE],
  APPROVAL_READ_SCOPES[ApprovalTypes.KNOWLEDGE_ARTICLE],
] as const;
